import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { format } from 'date-fns';
import { ReactElement } from 'react';

import { firstDayOf, IYearMonth } from '~/utils/date/date';

import ceStyles from '~/ui/pages/Clients/reusable/CommunityEngagement/CommunityEngagement.module.scss';

import styles from './MonthHeader.module.scss';

interface IMonthHeaderProps {
  selected: IYearMonth;
  onPrevious: () => void;
  onNext: () => void;
  showAddActions: boolean;
  showAddExemption: boolean;
  isAddExemptionDisabled: boolean;
  addExemptionTooltip: string;
  onAddExemption: () => void;
  isAddEntryDisabled: boolean;
  onAddEntry: () => void;
}

const MonthHeader = ({
  selected,
  onPrevious,
  onNext,
  showAddActions,
  showAddExemption,
  isAddExemptionDisabled,
  addExemptionTooltip,
  onAddExemption,
  isAddEntryDisabled,
  onAddEntry,
}: IMonthHeaderProps): ReactElement => {
  const date = firstDayOf(selected);

  return (
    <div className={ceStyles.card}>
      <div className={styles.monthHeader}>
        <div className={styles.monthNavigation}>
          <h3 className={styles.monthLabel}>
            <span className={styles.month}>{format(date, 'MMM')}</span>{' '}
            <span>{format(date, 'yyyy')}</span>
          </h3>
          <IconButton
            aria-label="Previous month"
            size="small"
            onClick={onPrevious}
            className={styles.monthArrow}
          >
            <ChevronLeft />
          </IconButton>
          <IconButton
            aria-label="Next month"
            size="small"
            onClick={onNext}
            className={styles.monthArrow}
          >
            <ChevronRight />
          </IconButton>
        </div>
        {showAddActions && (
          <div className={styles.monthActions}>
            {showAddExemption && (
              <Tooltip title={addExemptionTooltip} placement="top">
                <span>
                  <Button
                    color="primary"
                    variant="outlined"
                    disabled={isAddExemptionDisabled}
                    onClick={onAddExemption}
                    className={styles.monthAction}
                  >
                    Add Exemption
                  </Button>
                </span>
              </Tooltip>
            )}
            <Button
              color="primary"
              variant="contained"
              disabled={isAddEntryDisabled}
              onClick={onAddEntry}
              className={styles.monthAction}
            >
              Add Entry
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MonthHeader;
